import { useEffect } from "react";
import Lenis from "lenis";
import { trackPageView, trackPurchaseOnce } from "./analytics/metaPixel";
import Header from "./components/Header";
import PromoBar from "./components/PromoBar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Applications from "./components/Applications";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Program from "./components/Program";
import Trainers from "./components/Trainers";
import Faq from "./components/Faq";
import Offer from "./components/Offer";
import Footer from "./components/Footer";
import MobileBar from "./components/MobileBar";
import ThankYou from "./components/ThankYou";

const PATH = window.location.pathname.replace(/\/+$/, "") || "/";
const IS_THANK_YOU = PATH === "/dziekujemy" || PATH === "/dziekuje";

function App() {
  useEffect(() => {
    trackPageView(PATH);
    if (IS_THANK_YOU) {
      const params = new URLSearchParams(window.location.search);
      const value = Number.parseFloat(params.get("value"));
      trackPurchaseOnce("meta-purchase:umiem-uczyc-angielskiego", {
        content_name: "Umiem Uczyć Angielskiego",
        ...(Number.isFinite(value) ? { value, currency: params.get("currency") || "PLN" } : {}),
      });
      return undefined;
    }
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ anchors: true, lerp: 0.12 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  if (IS_THANK_YOU) {
    return (
      <div className="bg-white">
        <ThankYou />
      </div>
    );
  }

  return (
    <div className="bg-white">
      <PromoBar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Applications />
        <Gallery />
        <Testimonials />
        <Program />
        <Trainers />
        <Faq />
        <Offer />
      </main>
      <Footer />
      <div className="h-[72px] md:hidden" aria-hidden="true" />
      <MobileBar />
    </div>
  );
}

export default App;
